import {Navigate, Outlet, Route, Routes} from "react-router-dom";
import {EcommerceDashboard} from "./ecommerce-dasbhoard/EcommerceDashboard";
import {EcommerceVoucher} from "./ecommerce-voucher/EcommerceVoucher";
const EcommercePage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route path="*" element={<Navigate to="/ecommerce"/>}/>
                <Route path="/voucher" element={<EcommerceVoucher/>}/>
                <Route path={"/"} element={<EcommerceDashboard/>}/>
            </Route>
        </Routes>
    );
};

export default EcommercePage;